<template>
  <div>
    <v-card class="mt-3 mx-2 mb-5 elevation-2" color="grey lighten-4">
      <!-- <v-card-title class="headline ml-3 pt-4">
        </v-card-title> -->
      <v-card-text class="mt-0 pt-0 pt-4">
        <p class="text-xs-center headline">New Exhibition</p>
        <v-form v-model="valid" xs12 class="mt-0 pt-0">
          <v-container grid-list-md>
            <v-layout row wrap>
 
                <v-flex xs12 sm6 md6>
                  <v-radio-group v-model="exhibition.show_type" column>
                    <v-radio
                      label="Group Show"
                      value="2"
                    ></v-radio>
                    <v-radio
                      label="Solo Show"
                      value="1"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex xs12 sm6 md6 pt-3 class="align-end">
                  <v-switch v-model="exhibition.loan" label="Loan TBA21" value="1" color="black"></v-switch>
                </v-flex>

                <v-flex xs12 sm6 class='pr-3'>
                  <v-text-field
                    v-model="exhibition.title"
                    label="title"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class='pr-3'>
                  <v-text-field
                    v-model="exhibition.institution"
                    label="institution"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 class='pr-3'>
                  <v-text-field
                    v-model="exhibition.city"
                    label="city"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-autocomplete
                    :items="this.countries"
                    v-model="exhibition.country"
                    label="Select Country"
                  ></v-autocomplete>
                  <!-- <v-text-field
                    v-model="exhibition.country"
                    label="country"
                    required
                  ></v-text-field> -->
                </v-flex>

                  <v-flex xs12 sm4 md2 lg2 pr-3>
                    <v-text-field 
                      v-model="exhibition.duration_start_year"
                      label="Start Year"
                      placeholder="XXXX"
                      type="number"
                      :maxlength="4"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 pr-3>
                    <v-text-field
                      v-model="exhibition.duration_start_month"
                      label="Month"
                      placeholder="XX"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 pr-3>
                    <v-text-field
                      v-model="exhibition.duration_start_day"
                      label="Day"
                      placeholder="XX"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm4 md2 lg2 pr-3>
                    <v-text-field
                      v-model="exhibition.duration_end_year"
                      label="End Year"
                      placeholder="XXXX"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 pr-3>
                    <v-text-field
                      v-model="exhibition.duration_end_month"
                      label="Month"
                      placeholder="XX"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4 md2 lg2 pr-3>
                    <v-text-field
                      v-model="exhibition.duration_end_day"
                      label="Day"
                      placeholder="XX"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 pr-3>
                    <v-textarea
                      v-model="exhibition.admin_note"
                      label="Note"
                      auto-grow
                      clearable
                      rows=1
                    ></v-textarea>
                  </v-flex>
                <!-- </v-container> -->

                  <!-- <date-range :options="dateRangeOptions" @input="onDateRangeChange"></date-range> -->
                  <!-- <v-daterange
                    next-icon="arrow_forward"
                    prev-icon="arrow_back"
                    :options="dateRangeOptions"
                    @input="onDateRangeChange"
                    no-presets
                    model="exhibition.range"
                  /> -->
                  <!-- <v-menu
                    ref="menu_duration_start"
                    :close-on-content-click="false"
                    v-model="menu_duration_start"
                    :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px"
                  >
                    <v-text-field
                      v-model="exhibition.duration_start"
                      label="Duration Start"
                      prepend-icon="event" readonly slot="activator"
                    ></v-text-field>
                    <v-date-picker
                      v-model="date"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1970-01-01"
                      @change="save_menu_duration_start"
                      ref="picker"
                    ></v-date-picker>
                  </v-menu>

                  <v-text-field
                    v-model="exhibition.duration_start"
                    label="duration_start"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="exhibition.duration_end"
                    label="duration_end"
                    required
                  ></v-text-field> -->
                <v-card-actions class="my-3">
                  <v-flex xs12 sm12 md12>
                    <v-btn color="success" @click="save();$emit('show_form',false)">SAVE</v-btn>
                    <v-btn color="error" @click="$emit('show_form',false)">CANCEL</v-btn>
                  </v-flex>
                </v-card-actions>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>    
  </div>
</template>

<script>
  import { format, subDays } from 'date-fns'
  import axios from 'axios'

  export default {
    props: ['loan'],
    created () {
      this.exhibition.loan = ''
      this.exhibition.loan = toString(this.loan)
    },
    data () {
      return {
        valid: false,
        exhibition: {
          loan: false,
          title: '',
          institution: '',
          show_type: 1,
          city: '',
          country: '',
          duration_start_year: null,
          duration_start_month: null,
          duration_start_day: null,
          duration_end_year: null,
          duration_end_month: null,
          duration_end_day: null,
          admin_note: ''
          // menu_duration_start: false,
          // menu_duration_end: false,
          // range: []
        },
        dateRangeOptions: {
          startDate: format(subDays(new Date(), 7), 'YYYY-MM-DD'),
          endDate: format(new Date(), 'YYYY-MM-DD'),
          format: 'YYYY-MM-DD'
        },
        dateRangeOptionsWithMinDate: {
          startDate: format(subDays(new Date(), 7), 'YYYY-MM-DD'),
          endDate: format(new Date(), 'YYYY-MM-DD'),
          minDate: format(subDays(new Date(), 15), 'YYYY-MM-DD'),
          format: 'YYYY-MM-DD'
        },
        rules: {
          required: (value) => !!value || 'Required.',
          email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        }
      }
    },
    // watch: {
    //   menu_duration_start (val) {
    //     val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    //   },
    //   menu_duration_end (val) {
    //     val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    //   }
    // },
    computed: {
      countries () {
        return constants.COUNTRIES
      }
      // exhibitions () {
      //   // console.log('exa')
      //   return this.store_e.filter(t => {
      //     return t.exhibition_artworks.map(a => a = a.artwork_id).includes(this.artwork.id)
      // })
    },
    methods: {
      save () {      
        this.exhibition.duration_start_year = parseInt(this.exhibition.duration_start_year)
        this.exhibition.duration_start_month = parseInt(this.exhibition.duration_start_month)
        this.exhibition.duration_start_day = parseInt(this.exhibition.duration_start_day)
        this.exhibition.duration_end_year = parseInt(this.exhibition.duration_end_year)
        this.exhibition.duration_end_month = parseInt(this.exhibition.duration_end_month)
        this.exhibition.duration_end_day = parseInt(this.exhibition.duration_end_day)
        this.exhibition.artwork_id = this.$route.params.id
        // var id = this.findMinMax(this.$store.state.exhibitions)
        // this.exhibition.id = id
        // this.exhibition.exhibition_artworks = [{artwork_id: this.$route.params.id}]
        axios
          .post(`${this.$globals.apiserver}/exhibitions.json`, {
            exhibition: this.exhibition
          })
          .then(response => {
            this.errors = {};
            // this.exhibitions.push(response.data);
            this.$store.commit('ADD_EXHIBITION', response.data)
            // console.log(response)
            this.exhibition = {
              loan: false,
              title: '',
              institution: '',
              show_type: 1,
              city: '',
              country: '',
              duration_start_year: null,
              duration_start_month: null,
              duration_start_day: null,
              duration_end_year: null,
              duration_end_month: null,
              duration_end_day: null,
              admin_note: ''
              // menu_duration_start: false,
              // menu_duration_end: false,
              // range: []
            }
            // this.$store.dispatch('addExhibition', this.exhibition)
          })
          .catch(error => {
            // console.log(error)
            this.errors = error.response.data;
          });
      },
      onDateRangeChange(range) {
        this.exhibition.range = range
        this.exhibition.duration_start = range[0]
        this.exhibition.duration_end = range[1]
      },
      findMinMax(arr) {
        let max = arr[0].id
        for (let i = 1, len=arr.length; i < len; i++) {
          let v = arr[i].id
          max = (v > max) ? v : max
        }
        // console.log(max)
        return max
      }
      // save_menu_duration_start (date) {
      //   this.$refs.menu_duration_start.save(date)
      // },
      // save_menu_duration_end (date) {
      //   this.$refs.menu_duration_end.save(date)
      // },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artworks/NewExhibitionHistory.vue